<template>
  <div class="kw_tree_label">
    <!-- 第一层标签 -->
    <kw_tabs v-model="oneCurrent" scroll @tab-click="oneChange">
        <kw_tab v-for="(item,index) in treeArr" :key="'oneTab_'+index" :index="item.list_index" :name="item.ID" :title="item.NAME"></kw_tab>
    </kw_tabs>
    <!-- 第二层标签 -->
    <kw_tabs v-model="twoCurrent" :multiple="dataMaxNum" scroll @tab-click="twoChange">
      <div v-for="(item,index) in treeArr" :key="index" >
        <kw_tab v-for="(item,index) in item.children" :key="'twoTab_'+index" v-if="(twoInfo.PID==oneCurrent)" :index="twoInfo.list_index" :name="twoInfo.ID" :title="twoInfo.NAME"></kw_tab>
      </div>
    </kw_tabs>
    <button v-if="(dataMaxNum!=1)" @click="eventTrigger" >确定</button>
  </div>
</template>

<script>
// kw_tabs 标签组组件
import kw_tabs from '@/components/kw/kw_tabs.vue';
// kw_tab 标签组件
import kw_tab from '@/components/kw/kw_tab.vue';

export default {
  name: 'kw_tree_label',
  props: {
    pageSetInfo: {
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    // 初始的默认选中值
    initCheckId: {
      type: String,
      value: null
    },
    //可以选中几个数据
    dataMaxNum:{
      type: Number,
      value: 1
    }
  },
  data() {
    return {
      treeArr:[],
      oneCurrent:0,
      oneIndex:0,
      twoCurrent:0,
      twoIndex:[],
      checkDataInfo:[]
    };
  },
  created() {
    var that = this;
    var treeArr = utils.buildTree(that.dataList);
    var initCheckId = that.initCheckId;
    var oneCurrent = 0;
    var twoCurrent = "";
    var checkDataInfo = [];
    if (initCheckId != null && initCheckId !=undefined && initCheckId != "" && that.dataList.length > 0) {
      var initCheckIdArr = initCheckId.split(",");
      for (var i = 0; i < initCheckIdArr.length;i++) {
        var nowCheckEle = that.dataList[i];
        twoCurrent += (twoCurrent != "" ? ",":"")+nowCheckEle.ID;
        oneCurrent = nowCheckEle.PID;
        checkDataInfo.push(nowCheckEle);
      }
    } else {
      if (treeArr.length > 0) {
        oneCurrent = treeArr[0].ID;
      }
    }
    that.oneCurrent = oneCurrent;
    that.twoCurrent = twoCurrent;
    that.checkDataInfo = checkDataInfo;
    that.treeArr = treeArr;
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_tabs,
    kw_tab
  },
  methods: {
    oneChange(tab,event){
      that.oneCurrent = tab.name;
      that.oneIndex = tab.index;
      that.twoCurrent = 0;
      that.twoIndex = [];
    },
    twoChange(tab,event){
      var that = this;
      // console.log("detail===========================", detail);
      var twoCurrent = "";
      var twoIndex = [];
      if (this.dataMaxNum == 1) {
        //返回上一个页面 并切换数据ID 进行查看页面的数据切换
          twoCurrent = tab.key;
          twoIndex = [tab.index];
      } else {
        tab.forEach(item=>{
          if (twoCurrent != "") {
            twoCurrent+=",";
          }
          twoCurrent+=item.key;
          twoIndex.push(item.index);
        })
      }
      // console.log("twoCurrent============", twoCurrent);
      that.twoCurrent = twoCurrent;
      that.twoIndex = twoIndex;
      var checkDataInfo = [];
      var nowOneDataChild = that.dataList;
      // console.log("twoCurrent============", this.data.oneIndex, nowOneDataChild);
      twoIndex.forEach(item=>{
        checkDataInfo.push(nowOneDataChild[item]);
      })
      // console.log("checkDataInfo==================", checkDataInfo);
      that.checkDataInfo = checkDataInfo;
      if (that.dataMaxNum == 1) {
        that.eventTrigger();
      }
    },
    eventTrigger: function () {
      var twoCurrent = this.twoCurrent; //通过这个传递数据
      var checkDataInfo = this.checkDataInfo;
      var myEventDetail = {
        val: twoCurrent,
        checkDataInfo: checkDataInfo
      } // detail对象，提供给事件监听函数
      this.$emit("callbackevent", myEventDetail); //myevent自定义名称事件，父组件中使用
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
